import { createFileRoute } from '@tanstack/react-router'
import { PurchaseOrderDetail } from '@/features/parts/purchase-orders'
import { requireFlow } from '@/features/auth/guards'

export const Route = createFileRoute('/_authenticated/service/purchase-orders/$poId')({
  beforeLoad: requireFlow('service'),
  component: PurchaseOrderDetailPage,
})

function PurchaseOrderDetailPage() {
  const { poId } = Route.useParams()
  return <PurchaseOrderDetail poId={poId} />
}
